import "@babel/polyfill";

require('./style.scss');
